module.exports = __webpack_public_path__ + "img/somebodys favorite food.db6dba4f.png";